import { useStore } from '@stores';
import { useEffect } from 'react';

export const useTenantProfile = (id: number) => {
  const { tenantProfileStore } = useStore();
  const { tenantProfile, loading, clearTenantProfile } = tenantProfileStore;

  useEffect(() => {
    id && tenantProfileStore.getProfile({ id });

    return () => clearTenantProfile();
  }, [tenantProfileStore, id]);

  return { tenantProfile, loading };
};
